import { useMemo } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, EffectCoverflow, Autoplay } from 'swiper'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'
import 'swiper/css'
import 'swiper/css/effect-cube'
import Link from 'next/link'
import { getSpecialList_marketingModule_specials_edges_node } from '~/graphqls/types'

const StyledSwiper = styled(Swiper)`
  position: relative;
  margin-bottom: 40px;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: -40px;
  .swiper-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
  .swiper-pagination-bullet {
    width: 20px;
    height: 4px;
    border-radius: 2px;
    background: ${props => props.theme.light1};
    &.swiper-pagination-bullet-active {
      background: ${props => props.theme.primaryColor};
    }
  }
  .swiper-slide {
    border-radius: 16px;
    overflow: hidden;
  }
  .banner-image {
    width: 100%;
    height: 282px;
    border-radius: 16px;
    overflow: hidden;
  }
`
const StyledSingle = styled.div`
  padding-bottom: 40px;
  .banner-image {
    width: 100%;
    height: 366px;
    border-radius: 16px;
    overflow: hidden;
  }
`

export const SpecialModule: React.FC<{
  data: getSpecialList_marketingModule_specials_edges_node[]
}> = ({ data }) => {
  const onlyOne = useMemo(() => {
    return data.length === 1
  }, [data])
  return onlyOne ? (
    <StyledSingle>
      <Link href={`/mall/special/${data?.[0]?.slug}`}>
        <a>
          <MyImage
            tag="v1200"
            lazy={false}
            className="banner-image"
            src={data?.[0]?.imageUrl || ''}
          />
        </a>
      </Link>
    </StyledSingle>
  ) : (
    <StyledSwiper
      pagination={{
        clickable: true,
      }}
      effect={'coverflow'}
      slidesPerView={1.3}
      centeredSlides={true}
      loop={!onlyOne}
      coverflowEffect={{
        rotate: 0,
        scale: 2.3,
        depth: 2764,
        slideShadows: true,
      }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      modules={[EffectCoverflow, Autoplay, Pagination]}
    >
      {data.map(item => (
        <SwiperSlide key={item.slug}>
          <Link href={`/mall/special/${item.slug}`}>
            <a>
              <MyImage
                tag="v1200"
                lazy={false}
                className="banner-image"
                src={item.imageUrl}
              />
            </a>
          </Link>
        </SwiperSlide>
      ))}
    </StyledSwiper>
  )
}
